/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum SecurityFeatureType {
    RESIDUE = 'RESIDUE',
    TRACKING = 'TRACKING',
    CATCH_UP = 'CATCH_UP',
    INTEREST = 'INTEREST',
    PRINCIPAL = 'PRINCIPAL',
    OPTION = 'OPTION',
    LIQUIDATION_PREFERENCE = 'LIQUIDATION_PREFERENCE',
}
